var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplashje(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2905,
    height: 1030,
    viewBox: "0 0 2905 1030",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1476.11 696.288C1505.88 696.288 1530 684.6 1530 670.182C1530 655.764 1505.88 644.076 1476.11 644.076C1446.35 644.076 1422.22 655.764 1422.22 670.182C1422.22 684.6 1446.35 696.288 1476.11 696.288Z",
    strokeOpacity: 0.627,
    strokeWidth: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.11 695.389C1410.48 695.389 1435.11 684.104 1435.11 670.183C1435.11 656.262 1410.48 644.977 1380.11 644.977C1349.74 644.977 1325.12 656.262 1325.12 670.183C1325.12 684.104 1349.74 695.389 1380.11 695.389ZM1428.11 932.822C1459.09 932.822 1484.2 921.939 1484.2 908.516C1484.2 895.092 1459.09 884.21 1428.11 884.21C1397.13 884.21 1372.02 895.092 1372.02 908.516C1372.02 921.939 1397.13 932.822 1428.11 932.822Z",
    strokeOpacity: 0.627,
    strokeWidth: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 929.742C1459.7 929.742 1485.3 919.263 1485.3 906.336C1485.3 893.41 1459.7 882.93 1428.11 882.93C1396.53 882.93 1370.92 893.41 1370.92 906.336C1370.92 919.263 1396.53 929.742 1428.11 929.742Z",
    strokeOpacity: 0.627,
    strokeWidth: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 928.842C1460.31 928.842 1486.4 918.766 1486.4 906.336C1486.4 893.906 1460.31 883.83 1428.11 883.83C1395.92 883.83 1369.82 893.906 1369.82 906.336C1369.82 918.766 1395.92 928.842 1428.11 928.842Z",
    strokeOpacity: 0.627,
    strokeWidth: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 922.282C1460.91 922.282 1487.5 912.609 1487.5 900.676C1487.5 888.743 1460.91 879.07 1428.11 879.07C1395.31 879.07 1368.72 888.743 1368.72 900.676C1368.72 912.609 1395.31 922.282 1428.11 922.282Z",
    strokeOpacity: 0.627,
    strokeWidth: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 921.381C1461.52 921.381 1488.61 912.111 1488.61 900.675C1488.61 889.24 1461.52 879.969 1428.11 879.969C1394.7 879.969 1367.62 889.24 1367.62 900.675C1367.62 912.111 1394.7 921.381 1428.11 921.381Z",
    strokeOpacity: 0.627,
    strokeWidth: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 908.083C1462.13 908.083 1489.7 899.216 1489.7 888.277C1489.7 877.339 1462.13 868.471 1428.11 868.471C1394.1 868.471 1366.52 877.339 1366.52 888.277C1366.52 899.216 1394.1 908.083 1428.11 908.083Z",
    strokeOpacity: 0.627,
    strokeWidth: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 907.183C1462.74 907.183 1490.8 898.718 1490.8 888.277C1490.8 877.835 1462.74 869.371 1428.11 869.371C1393.49 869.371 1365.42 877.835 1365.42 888.277C1365.42 898.718 1393.49 907.183 1428.11 907.183Z",
    strokeOpacity: 0.627,
    strokeWidth: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 894.416C1463.34 894.416 1491.9 886.354 1491.9 876.41C1491.9 866.466 1463.34 858.404 1428.11 858.404C1392.88 858.404 1364.32 866.466 1364.32 876.41C1364.32 886.354 1392.88 894.416 1428.11 894.416Z",
    strokeOpacity: 0.627,
    strokeWidth: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 893.517C1463.95 893.517 1493 885.859 1493 876.411C1493 866.964 1463.95 859.305 1428.11 859.305C1392.27 859.305 1363.22 866.964 1363.22 876.411C1363.22 885.859 1392.27 893.517 1428.11 893.517Z",
    strokeOpacity: 0.627,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 887.299C1464.56 887.299 1494.11 880.044 1494.11 871.093C1494.11 862.143 1464.56 854.887 1428.11 854.887C1391.67 854.887 1362.12 862.143 1362.12 871.093C1362.12 880.044 1391.67 887.299 1428.11 887.299Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 886.399C1465.17 886.399 1495.2 879.546 1495.2 871.093C1495.2 862.64 1465.17 855.787 1428.11 855.787C1391.06 855.787 1361.02 862.64 1361.02 871.093C1361.02 879.546 1391.06 886.399 1428.11 886.399Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 882.236C1465.77 882.236 1496.3 875.787 1496.3 867.83C1496.3 859.874 1465.77 853.424 1428.11 853.424C1390.45 853.424 1359.92 859.874 1359.92 867.83C1359.92 875.787 1390.45 882.236 1428.11 882.236Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 881.338C1466.38 881.338 1497.4 875.291 1497.4 867.832C1497.4 860.373 1466.38 854.326 1428.11 854.326C1389.84 854.326 1358.82 860.373 1358.82 867.832C1358.82 875.291 1389.84 881.338 1428.11 881.338Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 879.107C1466.99 879.107 1498.5 873.463 1498.5 866.501C1498.5 859.539 1466.99 853.895 1428.11 853.895C1389.24 853.895 1357.72 859.539 1357.72 866.501C1357.72 873.463 1389.24 879.107 1428.11 879.107Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.11 878.205C1467.6 878.205 1499.61 872.964 1499.61 866.499C1499.61 860.034 1467.6 854.793 1428.11 854.793C1388.63 854.793 1356.62 860.034 1356.62 866.499C1356.62 872.964 1388.63 878.205 1428.11 878.205Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428 877.007C1468.09 877.007 1500.59 872.169 1500.59 866.201C1500.59 860.233 1468.09 855.395 1428 855.395C1387.91 855.395 1355.41 860.233 1355.41 866.201C1355.41 872.169 1387.91 877.007 1428 877.007Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428 876.105C1468.7 876.105 1501.69 871.67 1501.69 866.199C1501.69 860.728 1468.7 856.293 1428 856.293C1387.3 856.293 1354.31 860.728 1354.31 866.199C1354.31 871.67 1387.3 876.105 1428 876.105Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.88 875.205C1469.19 875.205 1502.67 871.173 1502.67 866.199C1502.67 861.225 1469.19 857.193 1427.88 857.193C1386.58 857.193 1353.09 861.225 1353.09 866.199C1353.09 871.173 1386.58 875.205 1427.88 875.205Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.88 874.306C1469.8 874.306 1503.77 870.677 1503.77 866.2C1503.77 861.724 1469.8 858.094 1427.88 858.094C1385.97 858.094 1351.99 861.724 1351.99 866.2C1351.99 870.677 1385.97 874.306 1427.88 874.306Z",
    strokeOpacity: 0.627,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 873.484C1470.4 873.484 1504.87 870.258 1504.87 866.278C1504.87 862.298 1470.4 859.072 1427.87 859.072C1385.35 859.072 1350.88 862.298 1350.88 866.278C1350.88 870.258 1385.35 873.484 1427.87 873.484Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 872.583C1471 872.583 1505.97 869.76 1505.97 866.277C1505.97 862.795 1471 859.971 1427.87 859.971C1384.74 859.971 1349.78 862.795 1349.78 866.277C1349.78 869.76 1384.74 872.583 1427.87 872.583Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 871.867C1471.61 871.867 1507.07 869.447 1507.07 866.461C1507.07 863.476 1471.61 861.055 1427.87 861.055C1384.14 861.055 1348.68 863.476 1348.68 866.461C1348.68 869.447 1384.14 871.867 1427.87 871.867Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 870.967C1472.22 870.967 1508.17 868.949 1508.17 866.461C1508.17 863.972 1472.22 861.955 1427.87 861.955C1383.53 861.955 1347.58 863.972 1347.58 866.461C1347.58 868.949 1383.53 870.967 1427.87 870.967Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 870.364C1472.83 870.364 1509.27 868.75 1509.27 866.758C1509.27 864.767 1472.83 863.152 1427.87 863.152C1382.92 863.152 1346.48 864.767 1346.48 866.758C1346.48 868.75 1382.92 870.364 1427.87 870.364Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 869.463C1473.43 869.463 1510.37 868.252 1510.37 866.757C1510.37 865.263 1473.43 864.051 1427.87 864.051C1382.31 864.051 1345.38 865.263 1345.38 866.757C1345.38 868.252 1382.31 869.463 1427.87 869.463Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 868.891C1474.04 868.891 1511.47 868.082 1511.47 867.085C1511.47 866.088 1474.04 865.279 1427.87 865.279C1381.71 865.279 1344.28 866.088 1344.28 867.085C1344.28 868.082 1381.71 868.891 1427.87 868.891Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 868.086C1474.65 868.086 1512.57 867.638 1512.57 867.086C1512.57 866.533 1474.65 866.086 1427.87 866.086C1381.1 866.086 1343.18 866.533 1343.18 867.086C1343.18 867.638 1381.1 868.086 1427.87 868.086Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 868.492C1475.26 868.492 1513.67 868.044 1513.67 867.492C1513.67 866.94 1475.26 866.492 1427.87 866.492C1380.49 866.492 1342.08 866.94 1342.08 867.492C1342.08 868.044 1380.49 868.492 1427.87 868.492Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 868.492C1475.86 868.492 1514.77 868.044 1514.77 867.492C1514.77 866.94 1475.86 866.492 1427.87 866.492C1379.88 866.492 1340.98 866.94 1340.98 867.492C1340.98 868.044 1379.88 868.492 1427.87 868.492Z",
    strokeOpacity: 0.627,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 869.02C1476.47 869.02 1515.87 868.572 1515.87 868.02C1515.87 867.468 1476.47 867.02 1427.87 867.02C1379.28 867.02 1339.88 867.468 1339.88 868.02C1339.88 868.572 1379.28 869.02 1427.87 869.02Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.87 869.02C1477.08 869.02 1516.97 868.572 1516.97 868.02C1516.97 867.468 1477.08 867.02 1427.87 867.02C1378.67 867.02 1338.78 867.468 1338.78 868.02C1338.78 868.572 1378.67 869.02 1427.87 869.02Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.74 869.605C1477.55 869.605 1517.93 869.157 1517.93 868.605C1517.93 868.053 1477.55 867.605 1427.74 867.605C1377.93 867.605 1337.55 868.053 1337.55 868.605C1337.55 869.157 1377.93 869.605 1427.74 869.605Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.74 869.605C1478.16 869.605 1519.03 869.157 1519.03 868.605C1519.03 868.053 1478.16 867.605 1427.74 867.605C1377.32 867.605 1336.45 868.053 1336.45 868.605C1336.45 869.157 1377.32 869.605 1427.74 869.605Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 870.777C1478.64 870.777 1520 870.329 1520 869.777C1520 869.225 1478.64 868.777 1427.61 868.777C1376.58 868.777 1335.22 869.225 1335.22 869.777C1335.22 870.329 1376.58 870.777 1427.61 870.777Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 870.777C1479.24 870.777 1521.1 870.329 1521.1 869.777C1521.1 869.225 1479.24 868.777 1427.61 868.777C1375.97 868.777 1334.12 869.225 1334.12 869.777C1334.12 870.329 1375.97 870.777 1427.61 870.777Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 872.674C1479.85 872.674 1522.2 872.227 1522.2 871.674C1522.2 871.122 1479.85 870.674 1427.61 870.674C1375.37 870.674 1333.02 871.122 1333.02 871.674C1333.02 872.227 1375.37 872.674 1427.61 872.674Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 872.674C1480.46 872.674 1523.3 872.227 1523.3 871.674C1523.3 871.122 1480.46 870.674 1427.61 870.674C1374.76 870.674 1331.92 871.122 1331.92 871.674C1331.92 872.227 1374.76 872.674 1427.61 872.674Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 874.914C1481.07 874.914 1524.4 874.466 1524.4 873.914C1524.4 873.361 1481.07 872.914 1427.61 872.914C1374.15 872.914 1330.82 873.361 1330.82 873.914C1330.82 874.466 1374.15 874.914 1427.61 874.914Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 874.914C1481.67 874.914 1525.5 874.466 1525.5 873.914C1525.5 873.361 1481.67 872.914 1427.61 872.914C1373.54 872.914 1329.72 873.361 1329.72 873.914C1329.72 874.466 1373.54 874.914 1427.61 874.914Z",
    strokeOpacity: 0.627,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 877.062C1482.28 877.062 1526.6 876.614 1526.6 876.062C1526.6 875.511 1482.28 875.062 1427.61 875.062C1372.94 875.062 1328.62 875.511 1328.62 876.062C1328.62 876.614 1372.94 877.062 1427.61 877.062Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 877.062C1482.89 877.062 1527.7 876.614 1527.7 876.062C1527.7 875.511 1482.89 875.062 1427.61 875.062C1372.33 875.062 1327.52 875.511 1327.52 876.062C1327.52 876.614 1372.33 877.062 1427.61 877.062Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 878.516C1483.5 878.516 1528.8 878.069 1528.8 877.516C1528.8 876.964 1483.5 876.516 1427.61 876.516C1371.72 876.516 1326.42 876.964 1326.42 877.516C1326.42 878.069 1371.72 878.516 1427.61 878.516Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 878.516C1484.1 878.516 1529.9 878.069 1529.9 877.516C1529.9 876.964 1484.1 876.516 1427.61 876.516C1371.11 876.516 1325.32 876.964 1325.32 877.516C1325.32 878.069 1371.11 878.516 1427.61 878.516Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.61 879.266C1484.71 879.266 1531 878.819 1531 878.266C1531 877.714 1484.71 877.266 1427.61 877.266C1370.51 877.266 1324.22 877.714 1324.22 878.266C1324.22 878.819 1370.51 879.266 1427.61 879.266Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.61 901.266C1486.31 901.266 1496.61 890.969 1496.61 878.266C1496.61 865.564 1486.31 855.266 1473.61 855.266C1460.91 855.266 1450.61 865.564 1450.61 878.266C1450.61 890.969 1460.91 901.266 1473.61 901.266Z",
    fill: "#005",
    fillOpacity: 0.541,
    strokeOpacity: 0.722,
    strokeWidth: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.61 894.369C1483.26 894.369 1490.28 887.355 1490.28 878.702C1490.28 870.049 1483.26 863.035 1474.61 863.035C1465.96 863.035 1458.94 870.049 1458.94 878.702C1458.94 887.355 1465.96 894.369 1474.61 894.369Z",
    fill: "#005",
    fillOpacity: 0.553,
    strokeOpacity: 0.737,
    strokeWidth: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.61 902.703C1392.86 902.703 1403.61 891.958 1403.61 878.703C1403.61 865.448 1392.86 854.703 1379.61 854.703C1366.35 854.703 1355.61 865.448 1355.61 878.703C1355.61 891.958 1366.35 902.703 1379.61 902.703Z",
    fill: "#005",
    fillOpacity: 0.565,
    strokeOpacity: 0.753,
    strokeWidth: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.5 895.207C1387.52 895.207 1394.83 887.894 1394.83 878.874C1394.83 869.853 1387.52 862.541 1378.5 862.541C1369.48 862.541 1362.17 869.853 1362.17 878.874C1362.17 887.894 1369.48 895.207 1378.5 895.207Z",
    fill: "#005",
    fillOpacity: 0.576,
    strokeOpacity: 0.769,
    strokeWidth: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2364.8 749.17H2381.93H2362.58M2360.33 753.297H2381.33H2359.33M2380.96 756.174H2358.59",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380.95 756.174H2358.94L2336.93 757.938L2314.92 761.466L2292.9 766.759L2270.9 773.816L2248.89 782.638",
    strokeOpacity: 0.627,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380.36 758.744H2359.35L2338.35 760.477L2317.34 763.94L2296.34 769.138L2275.35 776.066L2254.34 784.727L2233.34 795.119",
    strokeOpacity: 0.627,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380.36 758.744H2361L2341.64 760.444L2322.28 763.842L2302.93 768.941L2283.57 775.74L2264.22 784.237L2244.87 794.433L2225.5 806.329",
    strokeOpacity: 0.627,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2379.6 761.592H2362.48L2345.35 763.258L2328.24 766.591L2311.12 771.59L2293.99 778.255L2276.87 786.587L2259.75 796.584L2242.63 808.247L2225.5 821.577",
    strokeOpacity: 0.627,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2379.6 761.592H2365.23L2350.87 763.225L2336.5 766.49L2322.14 771.387L2307.77 777.917L2293.4 786.08L2279.04 795.876L2264.66 807.304L2250.3 820.365L2235.93 835.058",
    strokeOpacity: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2378.79 764.954H2367.62L2356.44 766.553L2345.27 769.749L2334.09 774.544L2322.92 780.938L2311.74 788.929L2300.57 798.521L2289.39 809.709L2278.22 822.496L2267.04 836.881L2255.87 852.864",
    strokeOpacity: 0.627,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2378.79 764.954H2371.15L2363.51 766.518L2355.87 769.645L2348.21 774.336L2340.57 780.591L2332.93 788.41L2325.29 797.792L2317.64 808.737L2310 821.246L2302.35 835.32L2294.71 850.957L2287.06 868.156",
    strokeOpacity: 0.627,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2378.01 768.377H2374.12L2370.24 769.905L2366.36 772.963L2362.48 777.548L2358.59 783.662L2354.72 791.304L2350.83 800.475L2346.95 811.175L2343.08 823.404L2339.19 837.159L2335.31 852.444L2331.43 869.259L2327.55 887.6",
    strokeOpacity: 0.627,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2378.01 768.377V769.87V772.855V777.334V783.306V790.77V799.727V810.178V822.12V835.556V850.484V866.906V884.821V904.229",
    strokeOpacity: 0.627,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2377.2 771.424H2381.08L2384.96 772.881L2388.84 775.795L2392.73 780.164L2396.6 785.992L2400.48 793.275L2404.37 802.017L2408.24 812.213L2412.13 823.869L2416.01 836.98L2419.89 851.547L2423.77 867.572L2427.66 885.054L2431.53 903.992L2435.42 924.386",
    strokeOpacity: 0.627,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2377.2 771.424H2384.84L2392.48 772.844L2400.14 775.685L2407.78 779.945L2415.42 785.627L2423.06 792.728L2430.71 801.249L2438.36 811.191L2446 822.553L2453.64 835.335L2461.29 849.538L2468.93 865.161L2476.57 882.204L2484.22 900.667L2491.87 920.551L2499.51 941.854",
    strokeOpacity: 0.627,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2376.46 774.817H2387.63L2398.8 776.2L2409.98 778.967L2421.15 783.116L2432.33 788.65L2443.5 795.566L2454.68 803.866L2465.85 813.549L2477.03 824.615L2488.2 837.065L2499.39 850.897L2510.56 866.114L2521.74 882.713L2532.91 900.696L2544.09 920.062L2555.26 940.811L2566.44 962.946",
    strokeOpacity: 0.627,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2376.46 774.817H2390.82L2405.19 776.162L2419.55 778.854L2433.92 782.893L2448.28 788.276L2462.65 795.005L2477.03 803.08L2491.39 812.502L2505.76 823.269L2520.12 835.383L2534.49 848.841L2548.85 863.647L2563.22 879.797L2577.59 897.294L2591.95 916.137L2606.32 936.325L2620.68 957.86L2635.05 980.735",
    strokeOpacity: 0.627,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2376.08 778.26H2393.21L2410.32 779.568L2427.44 782.184L2444.57 786.109L2461.68 791.34L2478.81 797.881L2495.93 805.73L2513.04 814.886L2530.17 825.352L2547.29 837.124L2564.42 850.206L2581.53 864.595L2598.65 880.292L2615.78 897.297L2632.9 915.612L2650.02 935.233L2667.14 956.163L2684.27 978.401L2701.39 1001.95",
    strokeOpacity: 0.627,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2376.08 778.26H2395.43L2414.78 779.53L2434.15 782.069L2453.5 785.879L2472.86 790.959L2492.21 797.308L2511.57 804.928L2530.93 813.818L2550.29 823.976L2569.64 835.405L2588.99 848.105L2608.35 862.074L2627.71 877.312L2647.07 893.822L2666.42 911.6L2685.77 930.65L2705.13 950.968L2724.48 972.557L2743.85 995.419L2763.2 1019.54",
    strokeOpacity: 0.627,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.67 781.255H2396.68L2417.68 782.486L2438.67 784.95L2459.68 788.643L2480.68 793.569L2501.69 799.725L2522.69 807.113L2543.69 815.732L2564.7 825.583L2585.69 836.666L2606.7 848.978L2627.7 862.524L2648.7 877.299L2669.71 893.306L2690.71 910.545L2711.72 929.015L2732.71 948.716L2753.71 969.647L2774.72 991.813L2795.72 1015.21L2816.73 1039.84",
    strokeOpacity: 0.627,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.67 781.255H2397.68L2419.7 782.448L2441.71 784.832L2463.71 788.41L2485.73 793.179L2507.74 799.14L2529.75 806.295L2551.76 814.642L2573.77 824.18L2595.78 834.912L2617.8 846.835L2639.8 859.953L2661.81 874.261L2683.83 889.762L2705.84 906.454L2727.84 924.341L2749.86 943.418L2771.87 963.693L2793.88 985.149L2815.89 1007.8L2837.9 1031.66L2859.91 1056.7",
    strokeOpacity: 0.627,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 783.389H2397.67L2420.02 784.542L2442.37 786.849L2464.72 790.307L2487.06 794.92L2509.41 800.685L2531.76 807.604L2554.12 815.675L2576.47 824.9L2598.82 835.277L2621.17 846.807L2643.52 859.491L2665.87 873.328L2688.22 888.317L2710.57 904.46L2732.92 921.755L2755.27 940.204L2777.63 959.806L2799.98 980.565L2822.33 1002.47L2844.67 1025.53L2867.02 1049.74L2889.37 1075.11",
    strokeOpacity: 0.627,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 783.389H2397.33L2419.33 784.502L2441.35 786.729L2463.36 790.069L2485.36 794.523L2507.38 800.089L2529.39 806.77L2551.4 814.564L2573.42 823.47L2595.42 833.492L2617.43 844.625L2639.45 856.873L2661.46 870.234L2683.46 884.707L2705.48 900.295L2727.49 916.996L2749.5 934.809L2771.51 953.737L2793.52 973.779L2815.53 994.93L2837.55 1017.21L2859.55 1040.58L2881.56 1065.07L2903.58 1090.68",
    strokeOpacity: 0.627,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 784.729H2396.31L2417.31 785.802L2438.32 787.949L2459.32 791.169L2480.33 795.463L2501.33 800.829L2522.34 807.27L2543.34 814.784L2564.33 823.37L2585.34 833.031L2606.34 843.764L2627.35 855.571L2648.35 868.452L2669.35 882.406L2690.36 897.433L2711.35 913.534L2732.35 930.708L2753.36 948.956L2774.36 968.278L2795.37 988.671L2816.37 1010.14L2837.38 1032.68L2858.37 1056.29L2879.37 1080.98L2900.38 1106.74",
    strokeOpacity: 0.627,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 784.729H2394.67L2414.03 785.762L2433.38 787.828L2452.73 790.927L2472.1 795.06L2491.45 800.224L2510.81 806.422L2530.16 813.654L2549.51 821.918L2568.88 831.215L2588.23 841.545L2607.59 852.909L2626.94 865.305L2646.3 878.736L2665.65 893.198L2685.02 908.693L2704.37 925.222L2723.72 942.784L2743.08 961.382L2762.43 981.005L2781.8 1001.67L2801.15 1023.36L2820.5 1046.08L2839.86 1069.85L2859.21 1094.65L2878.58 1120.47",
    strokeOpacity: 0.627,
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 786.018H2392.43L2409.55 787.009L2426.68 788.995L2443.8 791.972L2460.92 795.941L2478.04 800.903L2495.17 806.857L2512.29 813.804L2529.4 821.743L2546.53 830.674L2563.65 840.598L2580.78 851.515L2597.89 863.424L2615.01 876.325L2632.14 890.219L2649.25 905.104L2666.38 920.982L2683.5 937.852L2700.62 955.716L2717.74 974.573L2734.86 994.416L2751.99 1015.26L2769.11 1037.1L2786.23 1059.91L2803.35 1083.74L2820.47 1108.55L2837.6 1134.34",
    strokeOpacity: 0.627,
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 786.018H2389.68L2404.05 786.969L2418.42 788.871L2432.78 791.726L2447.15 795.532L2461.51 800.289L2475.88 805.997L2490.24 812.657L2504.61 820.269L2518.97 828.832L2533.35 838.346L2547.72 848.812L2562.08 860.229L2576.45 872.597L2590.81 885.918L2605.18 900.189L2619.55 915.413L2633.91 931.587L2648.28 948.713L2662.64 966.785L2677.01 985.821L2691.39 1005.8L2705.75 1026.73L2720.12 1048.61L2734.48 1071.45L2748.85 1095.23L2763.21 1119.98L2777.58 1145.66",
    strokeOpacity: 0.627,
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 786.922H2386.49L2397.67 787.832L2408.84 789.652L2420.02 792.383L2431.19 796.024L2442.37 800.575L2453.54 806.036L2464.72 812.407L2475.89 819.689L2487.06 827.88L2498.24 836.983L2509.41 846.994L2520.59 857.917L2531.76 869.749L2542.94 882.493L2554.12 896.145L2565.3 910.708L2576.47 926.181L2587.65 942.565L2598.82 959.859L2610 978.058L2621.17 997.18L2632.35 1017.21L2643.52 1038.14L2654.69 1059.99L2665.87 1082.74L2677.04 1106.39L2688.22 1130.97L2699.39 1156.46",
    strokeOpacity: 0.627,
    strokeWidth: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 786.922H2382.96L2390.6 787.79L2398.24 789.528L2405.9 792.134L2413.54 795.609L2421.18 799.952L2428.82 805.164L2436.47 811.244L2444.11 818.194L2451.76 826.012L2459.4 834.699L2467.05 844.255L2474.69 854.678L2482.33 865.972L2489.97 878.133L2497.63 891.162L2505.27 905.062L2512.91 919.828L2520.55 935.464L2528.2 951.969L2535.85 969.341L2543.49 987.583L2551.13 1006.69L2558.78 1026.68L2566.42 1047.53L2574.06 1069.24L2581.71 1091.82L2589.36 1115.28L2597 1139.6L2604.64 1164.8",
    strokeOpacity: 0.627,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 787.485H2379.19L2383.08 788.312L2386.96 789.966L2390.83 792.447L2394.72 795.754L2398.6 799.889L2402.48 804.85L2406.36 810.638L2410.25 817.253L2414.12 824.695L2418.01 832.964L2421.89 842.06L2425.76 851.982L2429.65 862.732L2433.53 874.308L2437.41 886.712L2441.29 899.941L2445.18 913.999L2449.05 928.883L2452.94 944.593L2456.82 961.138L2460.69 978.498L2464.58 996.691L2468.46 1015.7L2472.34 1035.56L2476.22 1056.22L2480.11 1077.72L2483.98 1100.05L2487.87 1123.21L2491.75 1147.18L2495.63 1171.99",
    strokeOpacity: 0.627,
    strokeWidth: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 787.485V788.27V789.84V792.195V795.333V799.258V803.967V809.462V815.74V822.804V830.652V839.286V848.703V858.906V869.895V881.667V894.225V907.567V921.694V936.607V952.304V968.791V986.054V1004.1V1022.94V1042.56V1062.97V1084.16V1106.14V1128.89V1152.44V1176.77",
    strokeOpacity: 0.627,
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 788.19H2371.43L2367.56 788.933L2363.67 790.418L2359.79 792.646L2355.9 795.616L2352.03 799.33L2348.14 803.785L2344.27 808.982L2340.39 814.923L2336.5 821.607L2332.63 829.033L2328.74 837.201L2324.86 846.111L2320.97 855.765L2317.1 866.161L2313.21 877.3L2309.34 889.181L2305.46 901.804L2301.57 915.171L2297.7 929.28L2293.81 944.131L2289.93 959.725L2286.04 976.065L2282.17 993.145L2278.28 1010.96L2274.41 1029.53L2270.53 1048.83L2266.64 1068.88L2262.77 1089.67L2258.88 1111.21L2255 1133.49L2251.11 1156.51L2247.24 1180.26",
    strokeOpacity: 0.627,
    strokeWidth: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 788.19H2367.67L2360.02 788.891L2352.38 790.291L2344.74 792.391L2337.09 795.191L2329.45 798.691L2321.81 802.892L2314.16 807.792L2306.51 813.393L2298.87 819.693L2291.23 826.695L2283.59 834.395L2275.93 842.797L2268.29 851.896L2260.65 861.698L2253.01 872.199L2245.36 883.4L2237.72 895.301L2230.07 907.903L2222.43 921.205L2214.78 935.206L2207.14 949.908L2199.5 965.306L2191.86 981.408L2184.2 998.206L2176.56 1015.71L2168.92 1033.92L2161.28 1052.82L2153.62 1072.42L2145.98 1092.73L2138.34 1113.72L2130.7 1135.43L2123.05 1157.83L2115.41 1180.94",
    strokeOpacity: 0.627,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 790.015H2364.14L2352.97 790.672L2341.78 791.987L2330.61 793.959L2319.43 796.589L2308.26 799.875L2297.08 803.819L2285.91 808.421L2274.74 813.679L2263.56 819.595L2252.39 826.169L2241.21 833.4L2230.04 841.289L2218.86 849.834L2207.69 859.038L2196.51 868.898L2185.34 879.415L2174.16 890.591L2162.99 902.423L2151.81 914.913L2140.63 928.06L2129.45 941.864L2118.28 956.326L2107.1 971.444L2095.93 987.227L2084.76 1003.66L2073.58 1020.75L2062.41 1038.49L2051.23 1056.9L2040.06 1075.96L2028.88 1095.68L2017.71 1116.07L2006.53 1137.09L1995.36 1158.8L1984.18 1181.14",
    strokeOpacity: 0.627,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 790.015H2360.95L2346.57 790.63L2332.21 791.858L2317.84 793.702L2303.48 796.159L2289.11 799.232L2274.75 802.918L2260.38 807.219L2246.02 812.135L2231.65 817.665L2217.28 823.809L2202.92 830.568L2188.55 837.942L2174.18 845.929L2159.81 854.531L2145.44 863.747L2131.08 873.578L2116.71 884.024L2102.35 895.084L2087.98 906.758L2073.62 919.047L2059.25 931.95L2044.89 945.468L2030.52 959.6L2016.14 974.341L2001.78 989.709L1987.41 1005.69L1973.05 1022.27L1958.68 1039.48L1944.31 1057.29L1929.95 1075.73L1915.58 1094.78L1901.22 1114.44L1886.85 1134.71L1872.49 1155.6L1858.12 1177.11",
    strokeOpacity: 0.627,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 795.77H2358.19L2341.07 796.342L2323.94 797.484L2306.83 799.198L2289.71 801.483L2272.58 804.34L2255.47 807.768L2238.34 811.767L2221.22 816.339L2204.11 821.48L2186.98 827.193L2169.86 833.478L2152.73 840.335L2135.62 847.762L2118.49 855.76L2101.37 864.331L2084.25 873.472L2067.13 883.184L2050.01 893.469L2032.88 904.324L2015.76 915.751L1998.65 927.748L1981.52 940.318L1964.4 953.459L1947.27 967.177L1930.16 981.457L1913.04 996.312L1895.91 1011.74L1878.8 1027.73L1861.67 1044.3L1844.55 1061.44L1827.42 1079.16L1810.31 1097.43L1793.19 1116.29L1776.06 1135.71L1758.94 1155.71L1741.82 1176.28",
    strokeOpacity: 0.627,
    strokeWidth: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 795.77H2355.95L2336.6 796.298L2317.24 797.354L2297.89 798.939L2278.54 801.05L2259.17 803.691L2239.82 806.86L2220.46 810.556L2201.11 814.78L2181.76 819.532L2162.4 824.814L2143.04 830.622L2123.68 836.959L2104.33 843.824L2084.98 851.216L2065.62 859.137L2046.26 867.586L2026.9 876.563L2007.55 886.068L1988.19 896.101L1968.84 906.662L1949.47 917.752L1930.12 929.369L1910.77 941.515L1891.41 954.188L1872.06 967.385L1852.71 981.115L1833.34 995.382L1813.99 1010.16L1794.63 1025.47L1775.28 1041.32L1755.92 1057.69L1736.56 1074.58L1717.2 1092.02L1697.85 1109.96L1678.5 1128.45L1659.14 1147.46L1639.78 1167",
    strokeOpacity: 0.627,
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 806.315H2354.31L2333.31 806.801L2312.31 807.769L2291.3 809.224L2270.3 811.162L2249.29 813.585L2228.3 816.492L2207.3 819.885L2186.29 823.762L2165.29 828.124L2144.28 832.971L2123.28 838.301L2102.28 844.116L2081.28 850.416L2060.28 857.201L2039.27 864.471L2018.27 872.225L1997.27 880.462L1976.26 889.186L1955.26 898.394L1934.27 908.086L1913.26 918.263L1892.26 928.925L1871.25 940.072L1850.25 951.702L1829.24 963.815L1808.24 976.42L1787.25 989.501L1766.24 1003.07L1745.24 1017.13L1724.23 1031.67L1703.23 1046.68L1682.23 1062.2L1661.22 1078.19L1640.23 1094.67L1619.23 1111.63L1598.22 1129.07L1577.22 1147.01L1556.21 1165.42",
    strokeOpacity: 0.627,
    strokeWidth: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375.32 806.315H2353.3L2331.29 806.757L2309.29 807.638L2287.27 808.962L2265.26 810.727L2243.25 812.931L2221.23 815.578L2199.23 818.665L2177.22 822.193L2155.2 826.162L2133.19 830.573L2111.19 835.424L2089.17 840.717L2067.16 846.45L2045.15 852.625L2023.14 859.241L2001.13 866.296L1979.12 873.794L1957.1 881.733L1935.1 890.112L1913.09 898.934L1891.07 908.195L1869.06 917.897L1847.06 928.041L1825.04 938.627L1803.03 949.652L1781.02 961.125L1759.01 973.033L1737 985.381L1714.99 998.17L1692.97 1011.4L1670.97 1025.07L1648.96 1039.19L1626.94 1053.74L1604.93 1068.74L1582.93 1084.17L1560.91 1100.05L1538.9 1116.36L1516.89 1133.12L1494.87 1150.32",
    strokeOpacity: 0.627,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2374.59 818.321H2352.22L2329.87 818.719L2307.53 819.513L2285.18 820.704L2262.83 822.293L2240.48 824.28L2218.13 826.664L2195.78 829.446L2173.43 832.624L2151.07 836.201L2128.72 840.173L2106.37 844.544L2084.02 849.312L2061.67 854.476L2039.32 860.039L2016.97 865.999L1994.63 872.355L1972.28 879.11L1949.93 886.262L1927.57 893.811L1905.22 901.758L1882.87 910.101L1860.52 918.842L1838.17 927.98L1815.82 937.515L1793.47 947.449L1771.12 957.778L1748.77 968.509L1726.41 979.635L1704.06 991.152L1681.71 1003.07L1659.36 1015.38L1637.01 1028.1L1614.67 1041.22L1592.32 1054.73L1569.97 1068.63L1547.62 1082.93L1525.26 1097.63L1502.91 1112.73L1480.56 1128.23L1458.21 1144.12",
    strokeOpacity: 0.627,
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2374.58 818.321H2352.57L2330.56 818.675L2308.55 819.381L2286.53 820.441L2264.53 821.856L2242.52 823.622L2220.5 825.744L2198.49 828.218L2176.49 831.046L2154.47 834.227L2132.46 837.762L2110.45 841.65L2088.44 845.892L2066.43 850.487L2044.42 855.436L2022.4 860.738L2000.4 866.394L1978.39 872.403L1956.37 878.765L1934.36 885.481L1912.36 892.55L1890.34 899.974L1868.33 907.75L1846.32 915.88L1824.3 924.364L1802.3 933.2L1780.29 942.391L1758.27 951.934L1736.27 961.834L1714.26 972.079L1692.24 982.691L1670.23 993.646L1648.23 1004.96L1626.21 1016.62L1604.2 1028.64L1582.19 1041.01L1560.17 1053.74L1538.17 1066.82L1516.15 1080.24L1494.14 1094.03L1472.13 1108.17L1450.12 1122.67",
    strokeOpacity: 0.627,
    strokeWidth: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2372.37 829.691H2351.37L2330.36 830.002L2309.36 830.621L2288.36 831.549L2267.35 832.787L2246.35 834.335L2225.35 836.192L2204.35 838.358L2183.35 840.835L2162.34 843.621L2141.34 846.716L2120.33 850.121L2099.33 853.835L2078.34 857.859L2057.33 862.192L2036.33 866.835L2015.32 871.788L1994.32 877.05L1973.32 882.622L1952.31 888.502L1931.32 894.692L1910.31 901.193L1889.31 908.003L1868.31 915.122L1847.3 922.55L1826.3 930.288L1805.29 938.335L1784.3 946.693L1763.3 955.36L1742.29 964.341L1721.29 973.621L1700.28 983.218L1679.28 993.121L1658.28 1003.34L1637.28 1013.86L1616.28 1024.69L1595.27 1035.84L1574.27 1047.29L1553.27 1059.06L1532.26 1071.12L1511.26 1083.51L1490.25 1096.2L1469.26 1109.2",
    strokeOpacity: 0.627,
    strokeWidth: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2372.37 829.691H2353.01L2333.65 829.958L2314.3 830.489L2294.94 831.285L2275.59 832.347L2256.22 833.675L2236.87 835.266L2217.52 837.126L2198.16 839.25L2178.81 841.639L2159.46 844.293L2140.09 847.214L2120.74 850.4L2101.38 853.851L2082.03 857.568L2062.67 861.55L2043.31 865.797L2023.96 870.311L2004.6 875.09L1985.25 880.133L1965.89 885.443L1946.53 891.018L1927.17 896.86L1907.82 902.966L1888.47 909.338L1869.11 915.974L1849.76 922.877L1830.39 930.045L1811.04 937.478L1791.69 945.177L1772.33 953.142L1752.98 961.37L1733.61 969.867L1714.26 978.634L1694.9 987.656L1675.55 996.948L1656.2 1006.51L1636.83 1016.33L1617.48 1026.41L1598.12 1036.77L1578.77 1047.39L1559.42 1058.27L1540.06 1069.42L1520.7 1080.84",
    strokeOpacity: 0.627,
    strokeWidth: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370 838.787H2352.87L2335.76 839.008L2318.63 839.451L2301.51 840.115L2284.39 841L2267.27 842.108L2250.15 843.435L2233.02 844.984L2215.9 846.756L2198.79 848.748L2181.66 850.962L2164.54 853.397L2147.41 856.053L2130.3 858.931L2113.17 862.03L2096.05 865.351L2078.94 868.892L2061.81 872.656L2044.69 876.64L2027.56 880.846L2010.45 885.273L1993.33 889.921L1976.2 894.791L1959.08 899.883L1941.96 905.195L1924.84 910.729L1907.72 916.485L1890.59 922.461L1873.48 928.659L1856.35 935.079L1839.23 941.719L1822.1 948.582L1804.99 955.665L1787.87 962.97L1770.74 970.502L1753.63 978.241L1736.5 986.212L1719.38 994.403L1702.26 1002.81L1685.14 1011.45L1668.02 1020.3L1650.89 1029.38L1633.77 1038.67L1616.66 1048.2L1599.53 1057.93",
    strokeOpacity: 0.627,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2486.83 770.214C2519.08 770.214 2545.25 744.06 2545.25 711.798C2545.25 679.535 2519.08 653.381 2486.83 653.381C2454.57 653.381 2428.42 679.535 2428.42 711.798C2428.42 744.06 2454.57 770.214 2486.83 770.214Z",
    fill: "#005",
    fillOpacity: 0.541,
    strokeOpacity: 0.722,
    strokeWidth: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2487.92 756.975C2509.89 756.975 2527.72 739.161 2527.72 717.185C2527.72 695.208 2509.89 677.393 2487.92 677.393C2465.94 677.393 2448.12 695.208 2448.12 717.185C2448.12 739.161 2465.94 756.975 2487.92 756.975Z",
    fill: "#005",
    fillOpacity: 0.553,
    strokeOpacity: 0.737,
    strokeWidth: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2246.64 778.14C2280.3 778.14 2307.59 750.849 2307.59 717.184C2307.59 683.518 2280.3 656.229 2246.64 656.229C2212.97 656.229 2185.68 683.518 2185.68 717.184C2185.68 750.849 2212.97 778.14 2246.64 778.14Z",
    fill: "#005",
    fillOpacity: 0.565,
    strokeOpacity: 0.753,
    strokeWidth: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2243.22 761.177C2266.13 761.177 2284.71 742.604 2284.71 719.694C2284.71 696.783 2266.13 678.211 2243.22 678.211C2220.32 678.211 2201.73 696.783 2201.73 719.694C2201.73 742.604 2220.32 761.177 2243.22 761.177Z",
    fill: "#005",
    fillOpacity: 0.576,
    strokeOpacity: 0.769,
    strokeWidth: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.91 548.427 1224.64 537.486M1224.64 559.367 1234.91 548.426M1214.37 548.429 1224.64 559.369M1224.64 537.485 1214.37 548.426M1235.09 548.656C1234.45 548.124 1233.88 547.497 1233.41 546.795M1232.98 568.673C1233.48 567.993 1234.07 567.392 1234.73 566.888M1214.19 566.429C1214.83 566.962 1215.4 567.588 1215.87 568.29M1216.3 546.414C1215.8 547.094 1215.21 547.695 1214.55 548.199M1235.62 548.9C1238.44 550.706 1240.72 553.342 1242.17 556.493M1241.31 578.355C1239.62 581.364 1237.14 583.789 1234.18 585.337M1213.66 584.419C1210.84 582.613 1208.56 579.977 1207.11 576.826M1207.97 554.967C1209.66 551.957 1212.14 549.533 1215.1 547.985M1219.03 555.521C1222.48 557.12 1225.56 559.508 1228.05 562.517 1230.54 565.525 1232.38 569.081 1233.44 572.93M1232.15 594.768C1230.65 598.446 1228.41 601.728 1225.58 604.38 1222.76 607.033 1219.42 608.991 1215.81 610.116M1195.31 608.742C1191.85 607.142 1188.77 604.754 1186.28 601.745 1183.8 598.737 1181.96 595.182 1180.9 591.332M1182.19 569.495C1183.69 565.817 1185.93 562.536 1188.76 559.883 1191.58 557.231 1194.92 555.272 1198.53 554.147M1215.33 417.078C1220.91 419.256 1225.86 422.944 1229.69 427.779 1233.53 432.614 1236.11 438.429 1237.2 444.653M1235.48 466.457C1233.44 472.401 1229.98 477.675 1225.44 481.761 1220.9 485.846 1215.44 488.603 1209.6 489.76M1189.13 487.93C1183.55 485.751 1178.6 482.063 1174.77 477.228 1170.93 472.393 1168.34 466.578 1167.26 460.355M1168.98 438.55C1171.02 432.607 1174.48 427.333 1179.02 423.247 1183.56 419.161 1189.02 416.404 1194.86 415.247M1199.23 429.265C1206.96 432.018 1213.79 437.064 1218.91 443.809 1224.04 450.555 1227.25 458.719 1228.17 467.343M1226.03 489.107C1223.44 497.338 1218.71 504.613 1212.38 510.075 1206.05 515.537 1198.38 518.96 1190.29 519.942M1169.86 517.654C1162.13 514.901 1155.3 509.855 1150.18 503.11 1145.05 496.364 1141.84 488.2 1140.92 479.576M1148 596.561C1150.59 588.329 1155.32 581.055 1161.65 575.593 1167.99 570.131 1175.65 566.708 1183.74 565.726",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.17 429.675C1211.05 433.043 1219.73 439.518 1226.09 448.247C1232.44 456.976 1236.17 467.55 1236.78 478.579M1234.2 500.288C1231.04 510.81 1224.96 520.065 1216.77 526.836C1208.58 533.607 1198.65 537.576 1188.3 538.222M1167.92 535.479C1158.05 532.111 1149.36 525.636 1143 516.907C1136.65 508.178 1132.92 497.604 1132.32 486.575M1134.89 464.868C1138.05 454.346 1144.13 445.091 1152.32 438.32C1160.51 431.549 1170.44 427.58 1180.79 426.934",
    strokeOpacity: 0.627,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.67 444.849C1197.69 448.894 1208.2 456.874 1215.72 467.653C1223.23 478.433 1227.36 491.462 1227.52 504.888M1224.52 526.536C1220.73 539.338 1213.24 550.54 1203.12 558.545C1193 566.55 1180.77 570.952 1168.17 571.124M1147.85 567.929C1135.83 563.884 1125.32 555.904 1117.8 545.125C1110.29 534.345 1106.16 521.316 1106 507.89M1109 486.242C1112.79 473.439 1120.28 462.238 1130.4 454.232C1140.52 446.227 1152.75 441.825 1165.35 441.653",
    strokeOpacity: 0.627,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.3 445.413C1202.45 450.21 1214.75 459.774 1223.35 472.665C1231.95 485.556 1236.38 501.074 1235.98 516.883M1232.56 538.458C1228.05 553.528 1219.08 566.63 1206.98 575.791C1194.88 584.952 1180.31 589.675 1165.47 589.249M1145.22 585.601C1131.07 580.805 1118.77 571.24 1110.18 558.35C1101.58 545.459 1097.14 529.94 1097.54 514.131M1100.97 492.555C1105.47 477.486 1114.45 464.383 1126.55 455.222C1138.65 446.061 1153.21 441.338 1168.05 441.764",
    strokeOpacity: 0.627,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.87 461.193C1191.13 466.821 1205.16 478.049 1214.77 493.108C1224.37 508.167 1229.01 526.203 1227.94 544.375M1224.08 565.868C1218.8 583.184 1208.26 598.136 1194.13 608.37C1179.99 618.604 1163.06 623.539 1146 622.398M1125.83 618.3C1109.58 612.672 1095.54 601.444 1085.94 586.385C1076.33 571.326 1071.7 553.29 1072.77 535.118M1076.62 513.622C1081.9 496.306 1092.44 481.354 1106.58 471.12C1120.71 460.886 1137.64 455.951 1154.7 457.092",
    strokeOpacity: 0.627,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.19 461.955C1196.53 468.5 1212.25 481.47 1222.78 498.751C1233.32 516.033 1238.05 536.606 1236.2 557.117M1231.93 578.519C1225.79 598.057 1213.61 614.803 1197.39 626.025C1181.17 637.248 1161.86 642.286 1142.6 640.317M1122.51 635.77C1104.17 629.225 1088.45 616.255 1077.92 598.974C1067.39 581.693 1062.66 561.12 1064.5 540.609M1068.78 519.204C1074.92 499.666 1087.09 482.921 1103.31 471.698C1119.54 460.476 1138.85 455.438 1158.1 457.406",
    strokeOpacity: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.91 476.427C1188.31 483.975 1205.65 498.765 1217.03 518.318C1228.41 537.871 1233.13 560.998 1230.41 583.82M1225.72 605.125C1218.63 626.858 1204.75 645.336 1186.4 657.459C1168.04 669.582 1146.33 674.614 1124.91 671.712M1104.92 666.716C1084.52 659.168 1067.17 644.378 1055.79 624.825C1044.41 605.272 1039.69 582.145 1042.41 559.323M1047.1 538.015C1054.19 516.282 1068.07 497.805 1086.43 485.682C1104.78 473.558 1126.49 468.526 1147.91 471.428",
    strokeOpacity: 0.627,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.9 477.438C1194.33 486.077 1213.24 502.764 1225.38 524.635C1237.52 546.507 1242.14 572.198 1238.44 597.3M1233.33 618.495C1225.22 642.391 1209.56 662.535 1189.03 675.469C1168.5 688.404 1144.38 693.323 1120.82 689.381M1100.92 683.941C1078.49 675.302 1059.58 658.614 1047.44 636.743C1035.3 614.872 1030.69 589.181 1034.38 564.078M1039.49 542.881C1047.6 518.985 1063.27 498.841 1083.8 485.907C1104.33 472.972 1128.44 468.053 1152 471.995",
    strokeOpacity: 0.627,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.87 490.399C1189.3 500.218 1209.71 518.877 1222.52 543.11C1235.34 567.343 1239.75 595.606 1234.98 622.953M1229.46 644.031C1220.24 670.055 1202.73 691.798 1179.98 705.452C1157.23 719.107 1130.7 723.804 1105.03 718.721M1085.25 712.835C1060.82 703.016 1040.41 684.358 1027.6 660.125C1014.78 635.892 1010.37 607.628 1015.14 580.281M1020.66 559.204C1029.88 533.18 1047.39 511.438 1070.14 497.783C1092.89 484.128 1119.42 479.431 1145.09 484.514",
    strokeOpacity: 0.627,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.52 491.699C1195.91 502.786 1217.75 523.489 1231.16 550.125C1244.56 576.76 1248.66 607.598 1242.73 637.151M1236.79 658.099C1226.38 686.214 1206.95 709.483 1181.95 723.765C1156.95 738.046 1128 742.414 1100.26 736.09M1080.6 729.767C1054.21 718.68 1032.37 697.976 1018.96 671.341C1005.56 644.706 1001.46 613.867 1007.39 584.314M1013.33 563.366C1023.73 535.25 1043.17 511.981 1068.17 497.7C1093.17 483.418 1122.12 479.051 1149.86 485.374",
    strokeOpacity: 0.627,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.99 503.492C1193.31 515.936 1216.51 538.755 1230.42 567.829C1244.32 596.903 1248.01 630.316 1240.82 662.034M1234.47 682.847C1222.79 713.012 1201.37 737.733 1174.08 752.547C1146.79 767.361 1115.43 771.292 1085.66 763.629M1066.12 756.868C1037.81 744.424 1014.6 721.604 1000.7 692.53C986.791 663.456 983.102 630.043 990.295 598.325M996.643 577.512C1008.32 547.347 1029.74 522.626 1057.03 507.812C1084.33 492.998 1115.69 489.067 1145.46 496.73",
    strokeOpacity: 0.627,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.29 505.13C1200.49 519.019 1224.98 544.023 1239.3 575.57C1253.61 607.118 1256.79 643.1 1248.25 676.939M1241.49 697.603C1228.46 729.773 1204.99 755.87 1175.38 771.12C1145.76 786.371 1111.99 789.757 1080.23 780.658M1060.83 773.464C1030.63 759.576 1006.14 734.572 991.82 703.024C977.505 671.477 974.327 635.494 982.867 601.656M989.621 580.988C1002.66 548.817 1026.13 522.721 1055.74 507.47C1085.35 492.22 1119.13 488.834 1150.89 497.932",
    strokeOpacity: 0.627,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.37 516.271C1199.4 531.691 1225.11 558.946 1239.75 592.998C1254.38 627.049 1256.95 665.594 1246.97 701.505M1239.81 722.013C1225.34 756.142 1199.75 783.534 1167.79 799.124C1135.83 814.714 1099.65 817.448 1065.94 806.82M1046.69 799.194C1014.65 783.774 988.942 756.519 974.308 722.467C959.674 688.416 957.108 649.871 967.084 613.96M974.242 593.45C988.716 559.321 1014.3 531.929 1046.26 516.339C1078.23 500.749 1114.41 498.015 1148.11 508.643",
    strokeOpacity: 0.627,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.28 518.286C1207.11 535.323 1233.96 564.894 1248.82 601.477C1263.68 638.061 1265.53 679.155 1254.04 717.088M1246.47 737.435C1230.48 773.473 1202.73 802.078 1168.39 817.909C1134.05 833.74 1095.47 835.715 1059.87 823.465M1040.77 815.411C1006.94 798.374 980.092 768.803 965.232 732.219C950.372 695.636 948.518 654.541 960.017 616.608M967.577 596.261C983.569 560.223 1011.33 531.618 1045.67 515.787C1080.01 499.956 1118.58 497.981 1154.19 510.231",
    strokeOpacity: 0.627,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.26 529.001C1207.83 547.74 1235.74 579.689 1250.73 618.829C1265.72 657.969 1266.76 701.599 1253.66 741.5M1245.7 761.673C1228.11 799.567 1198.12 829.3 1161.38 845.273C1124.64 861.246 1083.69 862.355 1046.24 848.392M1027.3 839.913C991.732 821.173 963.822 789.225 948.829 750.085C933.836 710.945 932.795 667.315 945.901 627.413M953.859 607.241C971.449 569.347 1001.44 539.613 1038.18 523.641C1074.92 507.668 1115.87 506.558 1153.32 520.521",
    strokeOpacity: 0.627,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.78 531.441C1216.04 551.965 1244.93 586.351 1259.96 628.069C1274.99 669.787 1275.12 715.934 1260.32 757.747M1251.97 777.738C1232.7 817.432 1200.42 848.207 1161.27 864.221C1122.11 880.235 1078.79 880.373 1039.54 864.608M1020.78 855.709C983.521 835.185 954.633 800.799 939.601 759.081C924.57 717.363 924.44 671.216 939.238 629.403M947.592 609.411C966.857 569.717 999.134 538.941 1038.29 522.927C1077.45 506.913 1120.77 506.775 1160.01 522.54",
    strokeOpacity: 0.627,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.33 542.285C1218.23 564.677 1248.01 601.556 1262.99 645.871C1277.96 690.186 1277.08 738.826 1260.51 782.492M1251.76 802.29C1230.74 843.726 1196.13 875.455 1154.53 891.409C1112.93 907.363 1067.28 906.424 1026.29 888.77M1007.71 879.454C968.813 857.061 939.031 820.182 924.055 775.867C909.079 731.552 909.961 682.912 926.532 639.246M935.278 619.447C956.296 578.011 990.913 546.282 1032.51 530.328C1074.11 514.374 1119.76 515.313 1160.75 532.967",
    strokeOpacity: 0.627,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.44 545.186C1226.91 569.526 1257.5 608.954 1272.32 655.88C1287.15 702.807 1285.15 753.916 1266.73 799.372M1257.6 818.972C1234.75 862.089 1197.74 894.679 1153.7 910.472C1109.65 926.265 1061.67 924.143 1019.01 904.515M1000.61 894.782C960.134 870.441 929.543 831.014 914.719 784.087C899.895 737.161 901.887 686.051 920.31 640.595M929.443 620.999C952.29 577.883 989.299 545.292 1033.35 529.499C1077.4 513.707 1125.37 515.829 1168.04 535.456",
    strokeOpacity: 0.627,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.99 555.764C1229.98 582.132 1261.3 624.158 1275.87 673.709C1290.45 723.259 1287.25 776.808 1266.89 823.99M1257.38 843.381C1232.63 888.115 1193.18 921.475 1146.67 937.003C1100.16 952.535 1049.89 949.125 1005.61 927.438M987.402 917.297C945.412 890.93 914.1 848.903 899.524 799.353C884.948 749.802 888.147 696.253 908.501 649.071M918.018 629.682C942.768 584.948 982.216 551.588 1028.73 536.06C1075.24 520.532 1125.5 523.94 1169.79 545.625",
    strokeOpacity: 0.627,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.65 559.169C1239.09 587.641 1271.04 632.316 1285.27 684.499C1299.5 736.682 1295 792.639 1272.63 841.479M1262.74 860.654C1236.01 906.938 1194.08 940.975 1145.1 956.135C1096.12 971.295 1043.59 966.495 997.747 942.675M979.747 932.132C936.302 903.66 904.355 858.985 890.124 806.803C875.894 754.62 880.398 698.663 902.76 649.823M912.655 630.644C939.381 584.359 981.315 550.325 1030.3 535.164C1079.28 520.004 1131.8 524.802 1177.65 548.625",
    strokeOpacity: 0.627,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.88 568.628C1243.72 599.28 1276.21 646.649 1289.99 701.47C1303.78 756.291 1297.88 814.62 1273.43 865.048M1263.16 883.998C1234.39 931.765 1189.93 966.374 1138.47 981.064C1087.01 995.754 1032.26 989.464 984.927 963.424M967.139 952.484C922.302 921.834 889.813 874.465 876.025 819.644C862.236 764.823 868.142 706.494 892.585 656.066M902.855 637.115C931.626 589.348 976.089 554.735 1027.55 540.046C1079.01 525.357 1133.76 531.648 1181.09 557.689",
    strokeOpacity: 0.627,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.19 569.938C1240.48 600.323 1270.65 646.384 1282.81 699.156C1294.98 751.928 1288.28 807.635 1264.02 855.434M1253.38 874.151C1224.86 919.202 1181.62 951.334 1132.09 964.294C1082.55 977.264 1030.26 970.124 985.393 944.274M967.828 932.941C925.54 902.556 895.376 856.495 883.209 803.723C871.042 750.951 877.743 695.244 902.005 647.444M912.643 628.729C941.164 583.677 984.401 551.543 1033.93 538.581C1083.47 525.619 1135.76 532.757 1180.63 558.604",
    strokeOpacity: 0.627,
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.72 575.347C1233.49 605.365 1261.39 650.036 1272.02 700.712C1282.65 751.388 1275.26 804.464 1251.27 849.666M1240.27 868.141C1212.09 910.512 1170.16 940.235 1122.59 951.565C1075.02 962.895 1025.2 955.015 982.774 929.459M965.43 917.735C925.659 887.717 897.757 843.046 887.125 792.37C876.492 741.694 883.885 688.617 907.875 643.416M918.881 624.938C947.058 582.567 988.99 552.841 1036.56 541.514C1084.12 530.186 1133.94 538.063 1176.37 563.62",
    strokeOpacity: 0.627,
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.32 576.408C1229.61 605.96 1255.32 649.161 1264.51 697.697C1273.69 746.233 1265.7 796.673 1242.08 839.311M1230.71 857.534C1202.97 897.26 1162.42 924.652 1116.86 934.438C1071.3 944.225 1023.96 935.714 983.935 910.544M966.829 898.438C929.54 868.886 903.828 825.684 894.642 777.148C885.456 728.613 893.444 678.172 917.07 635.534M928.436 617.308C956.175 577.582 996.726 550.19 1042.29 540.403C1087.84 530.617 1135.19 539.127 1175.21 564.297",
    strokeOpacity: 0.627,
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.35 580.233C1223.2 609.222 1246.79 650.876 1254.62 697.231C1262.45 743.586 1253.97 791.388 1230.79 831.499M1219.07 849.47C1191.86 886.591 1152.76 911.725 1109.25 920.066C1065.74 928.406 1020.87 919.368 983.218 894.68M966.354 882.19C931.51 853.201 907.918 811.547 900.089 765.192C892.26 718.837 900.743 671.034 923.917 630.924M935.638 612.956C962.848 575.835 1001.95 550.701 1045.46 542.361C1088.97 534.02 1133.84 543.058 1171.49 567.747",
    strokeOpacity: 0.627,
    strokeWidth: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.27 581.002C1218.71 609.331 1240.25 649.364 1246.82 693.5C1253.38 737.636 1244.5 782.803 1221.86 820.425M1209.79 838.127C1183.2 872.687 1145.62 895.64 1104.2 902.631C1062.77 909.621 1020.37 900.162 985.057 876.048M968.44 863.187C936.001 834.858 914.455 794.825 907.893 750.689C901.332 706.553 910.211 661.386 932.846 623.765M944.918 606.061C971.509 571.502 1009.09 548.548 1050.51 541.557C1091.94 534.567 1134.34 544.027 1169.65 568.14",
    strokeOpacity: 0.627,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.57 583.481C1212.65 611.055 1232.23 649.394 1237.61 691.277C1243 733.16 1233.82 775.695 1211.81 810.87M1199.39 828.3C1173.51 860.343 1137.52 881.197 1098.21 886.934C1058.9 892.672 1018.97 882.896 985.951 859.449M969.593 846.221C939.516 818.647 919.941 780.308 914.556 738.425C909.17 696.542 918.347 654.007 940.356 618.832M952.772 601.399C978.655 569.356 1014.64 548.502 1053.96 542.765C1093.27 537.027 1133.2 546.803 1166.21 570.25",
    strokeOpacity: 0.627,
    strokeWidth: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.82 583.914C1207.58 610.64 1225.26 647.217 1229.56 686.815C1233.86 726.413 1224.49 766.324 1203.19 799.098M1190.43 816.245C1165.34 845.82 1131.01 864.657 1093.84 869.239C1056.67 873.82 1019.21 863.833 988.446 841.142M972.348 827.551C944.587 800.825 926.905 764.249 922.605 724.651C918.304 685.053 927.679 645.141 948.978 612.368M961.738 595.218C986.824 565.643 1021.16 546.806 1058.33 542.224C1095.5 537.642 1132.96 547.63 1163.72 570.321",
    strokeOpacity: 0.627,
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.95 585.489C1201.44 611.275 1217.31 646.022 1220.62 683.307C1223.92 720.591 1214.45 757.891 1193.94 788.309M1180.85 805.169C1156.64 832.329 1124.03 849.234 1089.03 852.758C1054.03 856.283 1019.02 846.188 990.469 824.342M974.644 810.391C949.15 784.605 933.282 749.858 929.974 712.573C926.666 675.289 936.141 637.989 956.648 607.57M969.742 590.711C993.946 563.552 1026.56 546.647 1061.56 543.123C1096.56 539.598 1131.57 549.692 1160.12 571.539",
    strokeOpacity: 0.627,
    strokeWidth: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.54 585.542C1195.82 610.298 1209.96 643.153 1212.36 678.099C1214.77 713.045 1205.29 747.748 1185.66 775.861M1172.24 792.425C1149 817.224 1118.16 832.283 1085.36 834.849C1052.56 837.416 1019.99 827.317 993.596 806.401M978.047 792.1C954.769 767.344 940.634 734.489 938.225 699.543C935.816 664.597 945.295 629.895 964.928 601.782M978.35 585.22C1001.59 560.421 1032.43 545.362 1065.23 542.796C1098.03 540.23 1130.61 550.328 1156.99 571.244",
    strokeOpacity: 0.627,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.97 385.864C1095.09 409.501 1107.57 440.403 1109.17 472.989C1110.78 505.575 1101.39 537.697 1082.71 563.557M1068.97 579.817C1046.78 602.312 1017.77 615.615 987.186 617.323C956.599 619.03 926.447 609.031 902.174 589.129M886.909 574.488C865.793 550.85 853.307 519.949 851.704 487.363C850.101 454.777 859.487 422.654 878.168 396.795M891.913 380.535C914.1 358.039 943.106 344.736 973.693 343.029C1004.28 341.321 1034.43 351.321 1058.71 371.222",
    strokeOpacity: 0.627,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.22 385.499C1277.23 407.931 1288.16 436.822 1289.05 467.03C1289.94 497.237 1280.74 526.801 1263.09 550.461M1249.03 566.412C1227.97 586.665 1200.86 598.302 1172.5 599.251C1144.15 600.2 1116.4 590.4 1094.19 571.596M1079.22 556.618C1060.2 534.186 1049.28 505.295 1048.39 475.087C1047.5 444.88 1056.7 415.316 1074.35 391.656M1088.41 375.704C1109.46 355.45 1136.58 343.813 1164.94 342.864C1193.29 341.915 1221.04 351.715 1243.25 370.519",
    strokeOpacity: 0.627,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.29 586.464C1176.26 607.606 1185.7 634.431 1185.98 662.245C1186.25 690.059 1177.33 717.089 1160.79 738.605M1146.42 754.241C1126.57 772.316 1101.39 782.38 1075.29 782.671C1049.18 782.962 1023.81 773.462 1003.61 755.834M988.931 740.521C971.964 719.379 962.518 692.554 962.244 664.74C961.971 636.926 970.888 609.896 987.435 588.38M1001.81 572.749C1021.65 554.674 1046.83 544.61 1072.94 544.319C1099.05 544.028 1124.42 553.528 1144.62 571.156",
    strokeOpacity: 0.627,
    strokeWidth: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.67 585.645C1169.66 605.413 1177.72 630.122 1177.47 655.531C1177.22 680.939 1168.67 705.462 1153.3 724.892M1138.63 740.202C1120.07 756.166 1096.88 764.752 1073.03 764.486C1049.18 764.22 1026.16 755.118 1007.92 738.743M993.55 723.109C978.565 703.34 970.505 678.632 970.755 653.223C971.005 627.815 979.548 603.291 994.919 583.862M1009.6 568.552C1028.15 552.588 1051.34 544.002 1075.19 544.268C1099.04 544.534 1122.06 553.635 1140.3 570.01",
    strokeOpacity: 0.627,
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.51 585.499C1162.58 603.813 1169.35 626.357 1168.67 649.352C1167.99 672.347 1159.91 694.395 1145.79 711.798M1130.81 726.778C1113.62 740.703 1092.46 747.908 1070.88 747.185C1049.29 746.462 1028.6 737.856 1012.26 722.809M998.202 706.857C985.131 688.543 978.368 665.999 979.046 643.004C979.725 620.009 987.803 597.961 1001.93 580.558M1016.9 565.578C1034.09 551.653 1055.25 544.447 1076.84 545.17C1098.42 545.893 1119.12 554.499 1135.45 569.547",
    strokeOpacity: 0.627,
    strokeWidth: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.33 584.185C1155.55 600.964 1161.11 621.3 1160.1 641.877C1159.09 662.454 1151.56 682.059 1138.75 697.496M1123.49 712.136C1107.74 724.096 1088.65 730.02 1069.34 728.941C1050.02 727.863 1031.62 719.846 1017.13 706.198M1003.39 689.935C992.159 673.156 986.599 652.82 987.611 632.243C988.624 611.666 996.149 592.061 1008.96 576.624M1024.22 561.985C1039.97 550.025 1059.06 544.101 1078.38 545.179C1097.69 546.258 1116.09 554.275 1130.58 567.923",
    strokeOpacity: 0.627,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.45 583.183C1147.91 598.35 1152.36 616.436 1151.11 634.595C1149.86 652.754 1142.97 669.954 1131.54 683.486M1115.99 697.785C1101.76 707.859 1084.78 712.603 1067.73 711.269C1050.69 709.936 1034.54 702.601 1021.84 690.419M1008.42 673.855C998.963 658.688 994.51 640.602 995.762 622.443C997.014 604.284 1003.9 587.084 1015.33 573.552M1030.88 559.253C1045.12 549.179 1062.1 544.435 1079.14 545.768C1096.18 547.102 1112.33 554.437 1125.03 566.619",
    strokeOpacity: 0.627,
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.74 581.338C1140.5 594.816 1143.95 610.617 1142.55 626.361C1141.15 642.106 1134.99 656.94 1124.99 668.628M1109.16 682.577C1096.51 690.85 1081.68 694.519 1066.9 693.031C1052.12 691.542 1038.2 684.978 1027.23 674.325M1014.14 657.467C1006.37 643.99 1002.93 628.188 1004.33 612.444C1005.72 596.7 1011.88 581.866 1021.88 570.177M1037.71 556.226C1050.36 547.953 1065.19 544.283 1079.97 545.772C1094.75 547.26 1108.67 553.825 1119.64 564.477",
    strokeOpacity: 0.627,
    strokeWidth: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.35 579.436C1132.51 591.149 1135.05 604.634 1133.6 617.971C1132.15 631.309 1126.79 643.821 1118.28 653.725M1102.18 667.316C1091.19 673.88 1078.53 676.582 1066.01 675.039C1053.49 673.496 1041.75 667.785 1032.45 658.72M1019.69 641.572C1013.53 629.859 1010.99 616.374 1012.44 603.036C1013.89 589.698 1019.25 577.187 1027.76 567.282M1043.86 553.692C1054.85 547.128 1067.51 544.425 1080.03 545.969C1092.55 547.512 1104.29 553.222 1113.59 562.287",
    strokeOpacity: 0.627,
    strokeWidth: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.13 577.028C1124.78 586.901 1126.52 598.044 1125.11 608.989C1123.7 619.934 1119.22 630.169 1112.25 638.346M1095.89 651.578C1086.62 656.533 1076.16 658.382 1065.89 656.883C1055.61 655.384 1046 650.606 1038.33 643.178M1025.91 625.748C1021.26 615.875 1019.52 604.732 1020.93 593.787C1022.34 582.842 1026.82 572.607 1033.8 564.43M1050.16 551.2C1059.42 546.244 1069.88 544.395 1080.16 545.894C1090.43 547.393 1100.04 552.171 1107.71 559.599",
    strokeOpacity: 0.627,
    strokeWidth: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.45 574.625C1116.7 582.585 1117.75 591.367 1116.47 599.94C1115.2 608.512 1111.65 616.519 1106.25 623.019M1089.64 635.881C1082.16 639.343 1073.92 640.461 1065.87 639.103C1057.83 637.745 1050.31 633.968 1044.21 628.216M1032.14 610.511C1028.89 602.552 1027.84 593.77 1029.12 585.197C1030.39 576.624 1033.94 568.617 1039.33 562.117M1055.95 549.259C1063.42 545.797 1071.67 544.679 1079.71 546.037C1087.76 547.395 1095.27 551.172 1101.38 556.924",
    strokeOpacity: 0.627,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.53 588.924C1173.27 588.924 1190.9 570.146 1190.9 546.983C1190.9 523.821 1173.27 505.043 1151.53 505.043C1129.79 505.043 1112.16 523.821 1112.16 546.983C1112.16 570.146 1129.79 588.924 1151.53 588.924Z",
    fill: "#005",
    fillOpacity: 0.541,
    strokeOpacity: 0.722,
    strokeWidth: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.24 575.551C1168.05 575.551 1180.06 562.761 1180.06 546.983C1180.06 531.205 1168.05 518.414 1153.24 518.414C1138.43 518.414 1126.42 531.205 1126.42 546.983C1126.42 562.761 1138.43 575.551 1153.24 575.551Z",
    fill: "#005",
    fillOpacity: 0.553,
    strokeOpacity: 0.737,
    strokeWidth: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.435 590.532C1015.12 590.532 1033.51 570.939 1033.51 546.769C1033.51 522.599 1015.12 503.005 992.435 503.005C969.747 503.005 951.356 522.599 951.356 546.769C951.356 570.939 969.747 590.532 992.435 590.532Z",
    fill: "#005",
    fillOpacity: 0.565,
    strokeOpacity: 0.753,
    strokeWidth: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.724 576.551C1006.16 576.551 1018.68 563.216 1018.68 546.768C1018.68 530.319 1006.16 516.985 990.724 516.985C975.284 516.985 962.768 530.319 962.768 546.768C962.768 563.216 975.284 576.551 990.724 576.551Z",
    fill: "#005",
    fillOpacity: 0.576,
    strokeOpacity: 0.769,
    strokeWidth: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.286 331.21L552.425 334.174V2295.45L194.298 141.503",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.286 331.21L554.276 336.025L557.361 2295.45L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.286 331.21L556.127 337.876L562.297 2295.45L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.507 349.814L557.978 339.726L567.232 2282.67L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.507 349.814L559.829 341.577L572.168 2282.67L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.855 376.638L561.68 343.428L577.104 2268.01L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.855 376.638L563.531 345.279L582.039 2268.01L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.998 407.865L565.381 347.131L586.975 2257.16L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.998 407.864L567.232 348.98L591.91 2257.16L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.208 437.031L569.083 350.831L596.846 2251.37L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.208 437.032L570.934 352.683L601.782 2251.37L194.298 1156.39",
    strokeOpacity: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.852 462.486L572.785 354.533L606.717 2250.01L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.852 462.487L574.636 356.385L611.653 2250.01L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.895 487.495L576.487 358.234L616.588 2257.05L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.895 487.496L578.337 360.086L621.524 2257.06L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.904 505.849L580.188 361.937L626.46 2276.06L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.904 505.848L582.039 363.788L631.395 2276.06L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.872 514.73L583.89 365.639L636.331 2306.03L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.872 514.728L585.741 367.488L641.267 2306.03L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.847 517.084L587.592 369.34L646.202 2344.01L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.847 517.085L589.443 371.191L651.138 2344.01L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.033 509.836L591.293 373.042L656.073 2384.19L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.033 509.838L593.144 374.894L661.009 2384.19L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.587 490.683L594.995 376.743L665.945 2420.75L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.587 490.683L596.846 378.594L670.88 2420.75L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.012 462.27L598.697 380.445L675.816 2449.17L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.012 462.27L600.548 382.297L680.752 2449.17L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.641 429.302L602.399 384.147L685.687 2466.8L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.641 429.3L604.249 385.997L690.623 2466.8L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.841 398.81L606.1 387.849L695.558 2473L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.841 398.809L607.951 389.699L700.494 2473L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.666 373.86L609.802 391.55L705.43 2468.83L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.666 373.86L611.653 393.401L710.365 2468.83L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.772 354.448L613.504 395.252L715.301 2450.93L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.772 354.448L615.355 397.103L720.236 2450.93L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.328 341.808L617.205 398.955L725.172 2420.49L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.328 341.808L619.056 400.806L730.108 2420.49L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.323 335.788L620.907 402.655L735.043 2387.48L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.323 335.788L622.758 404.506L739.979 2387.48L194.298 1156.38",
    strokeOpacity: 0.627,
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.301 334.174L624.609 406.357L744.915 2358.46L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.301 334.174L626.46 408.208L749.85 2358.46L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.677 334.174L628.311 410.059L754.786 2335.84L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.677 334.174L630.161 411.91L759.721 2335.84L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.175 334.174L632.012 413.76L764.657 2320.33L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.175 334.174L633.863 415.611L769.593 2320.33L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.577 334.174L635.714 417.462L774.528 2309.74L194.298 1156.39",
    strokeOpacity: 0.627,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.526 369.649C653.118 369.649 669.001 353.766 669.001 334.174C669.001 314.582 653.118 298.699 633.526 298.699C613.934 298.699 598.052 314.582 598.052 334.174C598.052 353.766 613.934 369.649 633.526 369.649Z",
    fill: "#005",
    fillOpacity: 0.541,
    strokeOpacity: 0.722,
    strokeWidth: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.731 358.338C642.077 358.338 652.895 347.52 652.895 334.174C652.895 320.828 642.077 310.01 628.731 310.01C615.385 310.01 604.567 320.828 604.567 334.174C604.567 347.52 615.385 358.338 628.731 358.338Z",
    fill: "#005",
    fillOpacity: 0.553,
    strokeOpacity: 0.737,
    strokeWidth: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.205 371.191C502.649 371.191 519.222 354.618 519.222 334.174C519.222 313.73 502.649 297.157 482.205 297.157C461.761 297.157 445.188 313.73 445.188 334.174C445.188 354.618 461.761 371.191 482.205 371.191Z",
    fill: "#005",
    fillOpacity: 0.565,
    strokeOpacity: 0.753,
    strokeWidth: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.868 359.366C491.781 359.366 503.059 348.087 503.059 334.174C503.059 320.261 491.781 308.982 477.868 308.982C463.955 308.982 452.676 320.261 452.676 334.174C452.676 348.087 463.955 359.366 477.868 359.366Z",
    fill: "#005",
    fillOpacity: 0.576,
    strokeOpacity: 0.769,
    strokeWidth: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0109 630.581L79.6437 623.534C76.0109 630.581 15.2922 687.885 22.3391 684.253",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2109 631.78C77.2109 631.78 15.2921 687.885 23.539 685.452",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.411 632.98C78.411 632.98 15.2922 687.885 24.7391 686.652",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6109 634.181C79.6109 634.181 17.2375 686.785 25.939 687.853",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8109 635.381C80.8109 635.381 17.2375 686.784 27.139 689.052",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.011 636.581C82.011 636.581 19.1087 685.835 28.3392 690.253",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2108 637.78C83.2108 637.78 19.1085 685.834 29.539 691.452",
    strokeOpacity: 0.627,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4109 638.98C84.4109 638.98 20.7961 684.893 30.739 692.652",
    strokeOpacity: 0.627,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6109 640.181C85.6109 640.181 20.796 684.894 31.939 693.853",
    strokeOpacity: 0.627,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8109 641.381C86.8109 641.381 22.1515 684.135 33.139 695.052",
    strokeOpacity: 0.627,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0108 642.582L75.8936 630.394C88.0108 642.582 22.1514 684.136 34.3389 696.254",
    strokeOpacity: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2108 643.78C89.2108 643.78 23.253 683.557 35.539 697.452",
    strokeOpacity: 0.627,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.411 644.98C90.411 644.98 23.2531 683.557 36.7391 698.652",
    strokeOpacity: 0.627,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6109 646.181C91.6109 646.181 24.0421 683.062 37.939 699.853",
    strokeOpacity: 0.627,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.811 647.381C92.811 647.381 24.0422 683.061 39.1391 701.052",
    strokeOpacity: 0.627,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0109 648.581C94.0109 648.581 24.5734 682.721 40.339 702.253",
    strokeOpacity: 0.627,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.211 649.78C95.211 649.78 24.5735 682.721 41.5391 703.452",
    strokeOpacity: 0.627,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4109 650.98C96.4109 650.98 24.9952 682.494 42.739 704.652",
    strokeOpacity: 0.627,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.611 652.181C97.611 652.181 24.9953 682.495 43.9391 705.853",
    strokeOpacity: 0.627,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8109 653.381C98.8109 653.381 25.1789 682.37 45.139 707.052",
    strokeOpacity: 0.627,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.011 654.581L74.1281 633.421C100.011 654.581 25.1788 682.37 46.339 708.253",
    strokeOpacity: 0.627,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.211 655.78C101.211 655.78 25.0929 682.338 47.539 709.452",
    strokeOpacity: 0.627,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.411 656.98C102.411 656.98 25.093 682.338 48.7391 710.652",
    strokeOpacity: 0.627,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.611 658.181C103.611 658.181 24.9758 682.339 49.9391 711.853",
    strokeOpacity: 0.627,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.811 659.381C104.811 659.381 24.9757 682.338 51.139 713.052",
    strokeOpacity: 0.627,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.011 660.581C106.011 660.581 24.8702 682.339 52.339 714.253",
    strokeOpacity: 0.627,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.211 661.78C107.211 661.78 24.8704 682.338 53.5391 715.452",
    strokeOpacity: 0.627,
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.411 662.98C108.411 662.98 24.7022 682.338 54.7389 716.652",
    strokeOpacity: 0.627,
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.611 664.181C109.611 664.181 24.7023 682.339 55.939 717.853",
    strokeOpacity: 0.627,
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.811 665.381C110.811 665.381 24.5616 682.338 57.1389 719.052",
    strokeOpacity: 0.627,
    strokeWidth: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.011 666.582L74.0968 632.804C112.011 666.582 24.5616 682.34 58.3389 720.254",
    strokeOpacity: 0.627,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.211 667.78C113.211 667.78 24.3702 682.338 59.539 721.452",
    strokeOpacity: 0.627,
    strokeWidth: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.411 668.98C114.411 668.98 24.3703 682.338 60.739 722.652",
    strokeOpacity: 0.627,
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.611 670.181C115.611 670.181 24.132 682.456 61.939 723.853",
    strokeOpacity: 0.627,
    strokeWidth: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.811 671.381C116.811 671.381 24.132 682.456 63.139 725.052",
    strokeOpacity: 0.627,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.011 672.581C118.011 672.581 23.9248 682.573 64.3389 726.253",
    strokeOpacity: 0.627,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.211 673.78C119.211 673.78 23.9249 682.572 65.539 727.452",
    strokeOpacity: 0.627,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.411 674.98C120.411 674.98 23.8038 682.572 66.7389 728.652",
    strokeOpacity: 0.627,
    strokeWidth: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.611 676.181C121.611 676.181 23.8039 682.574 67.9391 729.853",
    strokeOpacity: 0.627,
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.811 677.381C122.811 677.381 23.6594 682.682 69.1391 731.052",
    strokeOpacity: 0.627,
    strokeWidth: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.011 678.581L74.4407 631.901C124.011 678.581 23.6594 682.682 70.3391 732.253",
    strokeOpacity: 0.627,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.211 679.78C125.211 679.78 23.4678 682.799 71.5389 733.452",
    strokeOpacity: 0.627,
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.411 680.98C126.411 680.98 23.468 682.799 72.7391 734.652",
    strokeOpacity: 0.627,
    strokeWidth: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.611 682.181C127.611 682.181 23.339 682.91 73.939 735.853",
    strokeOpacity: 0.627,
    strokeWidth: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.811 683.381C128.811 683.381 23.339 682.909 75.139 737.053",
    strokeOpacity: 0.627,
    strokeWidth: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.011 684.581C130.011 684.581 23.1594 683.152 76.3391 738.253",
    strokeOpacity: 0.627,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.91 654.401C133.612 654.401 143.91 644.104 143.91 631.401C143.91 618.699 133.612 608.401 120.91 608.401C108.207 608.401 97.9097 618.699 97.9097 631.401C97.9097 644.104 108.207 654.401 120.91 654.401Z",
    fill: "#005",
    fillOpacity: 0.541,
    strokeOpacity: 0.722,
    strokeWidth: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.175 646.822C130.827 646.822 137.842 639.808 137.842 631.155C137.842 622.502 130.827 615.488 122.175 615.488C113.522 615.488 106.508 622.502 106.508 631.155C106.508 639.808 113.522 646.822 122.175 646.822Z",
    fill: "#005",
    fillOpacity: 0.553,
    strokeOpacity: 0.737,
    strokeWidth: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1746 655.155C40.4294 655.155 51.1746 644.41 51.1746 631.155C51.1746 617.9 40.4294 607.155 27.1746 607.155C13.9197 607.155 3.17456 617.9 3.17456 631.155C3.17456 644.41 13.9197 655.155 27.1746 655.155Z",
    fill: "#005",
    fillOpacity: 0.565,
    strokeOpacity: 0.753,
    strokeWidth: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4997 647.176C35.5202 647.176 42.8327 639.863 42.8327 630.843C42.8327 621.822 35.5202 614.51 26.4997 614.51C17.4793 614.51 10.1667 621.822 10.1667 630.843C10.1667 639.863 17.4793 647.176 26.4997 647.176Z",
    fill: "#005",
    fillOpacity: 0.576,
    strokeOpacity: 0.769,
    strokeWidth: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.885 428.097C252.667 5.8479 314.885 379.209 240.613 428.097",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.885 429.319C42.1526 224.226 434.649 379.21 241.834 429.319",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.885 430.541C-28.0186 442.606 444.83 379.21 243.056 430.541",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.852 431.763C-63.1044 660.984 455.011 386.587 244.278 431.763",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.852 432.984C-84.1558 879.363 465.191 386.587 245.499 432.984",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.716 434.206C-98.19 1097.74 475.372 391.841 246.721 434.206",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.716 435.427C-108.215 1316.12 485.553 391.84 247.943 435.427",
    strokeOpacity: 0.627,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.28 436.649C-115.733 1534.49 495.734 396.187 249.165 436.649",
    strokeOpacity: 0.627,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.28 437.871C-121.581 1752.87 505.915 396.187 250.386 437.871",
    strokeOpacity: 0.627,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.846 439.093C-126.259 1971.25 516.096 399.293 251.608 439.093",
    strokeOpacity: 0.627,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.846 440.314C-130.086 2189.63 526.276 399.292 252.83 440.314",
    strokeOpacity: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.77 441.536C-133.276 2408.01 536.457 401.611 254.052 441.536",
    strokeOpacity: 0.627,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.77 442.758C-135.975 2626.39 546.638 401.611 255.273 442.758",
    strokeOpacity: 0.627,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.585 443.98C-138.288 2844.77 556.819 404.38 256.495 443.98",
    strokeOpacity: 0.627,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.585 445.201C-140.293 3063.15 567 404.379 257.716 445.201",
    strokeOpacity: 0.627,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.858 446.423C-142.047 3281.52 577.18 408.253 258.938 446.423",
    strokeOpacity: 0.627,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.858 447.645C-143.595 3499.9 587.361 408.253 260.16 447.645",
    strokeOpacity: 0.627,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.976 448.866C-144.971 3718.28 597.542 412.599 261.382 448.866",
    strokeOpacity: 0.627,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.976 450.088C-146.202 3936.66 607.723 412.6 262.603 450.088",
    strokeOpacity: 0.627,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.314 451.31C-147.31 4155.04 617.904 416.836 263.825 451.31",
    strokeOpacity: 0.627,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.314 452.531C-148.313 4373.42 628.085 416.835 265.047 452.531",
    strokeOpacity: 0.627,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.822 453.753C-149.224 4591.8 638.265 420.096 266.268 453.753",
    strokeOpacity: 0.627,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.822 454.976C-150.056 4810.18 648.446 420.097 267.49 454.976",
    strokeOpacity: 0.627,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.936 456.196C-150.819 5028.55 658.627 422.402 268.712 456.196",
    strokeOpacity: 0.627,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.936 457.417C-151.52 5246.93 668.808 422.402 269.934 457.417",
    strokeOpacity: 0.627,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.77 458.64C-152.168 5465.31 678.989 424.339 271.155 458.64",
    strokeOpacity: 0.627,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.77 459.862C-152.768 5683.69 689.17 424.339 272.377 459.862",
    strokeOpacity: 0.627,
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.817 461.083C-153.325 5902.07 699.35 425.536 273.599 461.083",
    strokeOpacity: 0.627,
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.817 462.304C-153.843 6120.45 709.531 425.535 274.82 462.304",
    strokeOpacity: 0.627,
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.814 463.527C-154.327 6338.83 719.712 426.252 276.042 463.527",
    strokeOpacity: 0.627,
    strokeWidth: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.815 464.749C-154.78 6557.21 729.893 426.253 277.264 464.749",
    strokeOpacity: 0.627,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.218 465.97C-155.204 6775.59 740.074 426.936 278.485 465.97",
    strokeOpacity: 0.627,
    strokeWidth: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.218 467.191C-155.603 6993.96 750.255 426.935 279.707 467.191",
    strokeOpacity: 0.627,
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.333 468.413C-155.978 7212.34 760.435 427.449 280.929 468.413",
    strokeOpacity: 0.627,
    strokeWidth: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.333 469.635C-156.332 7430.72 770.616 427.449 282.15 469.635",
    strokeOpacity: 0.627,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.319 470.858C-156.666 7649.1 780.797 427.741 283.372 470.858",
    strokeOpacity: 0.627,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.318 472.078C-156.982 7867.48 790.978 427.739 284.594 472.078",
    strokeOpacity: 0.627,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.65 473.3C-157.282 8085.86 801.159 427.898 285.816 473.3",
    strokeOpacity: 0.627,
    strokeWidth: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.65 474.522C-157.566 8304.24 811.34 427.898 287.037 474.522",
    strokeOpacity: 0.627,
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.268 475.744C-157.836 8522.61 821.52 428.03 288.259 475.744",
    strokeOpacity: 0.627,
    strokeWidth: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.269 476.965C-158.092 8740.99 831.701 428.03 289.481 476.965",
    strokeOpacity: 0.627,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.133 478.187C-158.337 8959.37 841.882 428.249 290.702 478.187",
    strokeOpacity: 0.627,
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.133 479.409C-158.57 9177.75 852.063 428.249 291.924 479.409",
    strokeOpacity: 0.627,
    strokeWidth: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.133 480.631C-158.793 9396.13 862.244 428.364 293.146 480.631",
    strokeOpacity: 0.627,
    strokeWidth: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.133 481.852C-159.005 9614.51 872.425 428.363 294.367 481.852",
    strokeOpacity: 0.627,
    strokeWidth: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3 483.074C-159.209 9832.89 882.605 428.368 295.589 483.074",
    strokeOpacity: 0.627,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.132 451.785C299.064 451.785 309.548 441.301 309.548 428.369C309.548 415.437 299.064 404.953 286.132 404.953C273.2 404.953 262.716 415.437 262.716 428.369C262.716 441.301 273.2 451.785 286.132 451.785Z",
    fill: "#005",
    fillOpacity: 0.541,
    strokeOpacity: 0.722,
    strokeWidth: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.588 444.318C296.397 444.318 303.538 437.177 303.538 428.368C303.538 419.559 296.397 412.418 287.588 412.418C278.779 412.418 271.638 419.559 271.638 428.368C271.638 437.177 278.779 444.318 287.588 444.318Z",
    fill: "#005",
    fillOpacity: 0.553,
    strokeOpacity: 0.737,
    strokeWidth: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.87 452.803C204.365 452.803 215.304 441.864 215.304 428.369C215.304 414.875 204.365 403.935 190.87 403.935C177.376 403.935 166.436 414.875 166.436 428.369C166.436 441.864 177.376 452.803 190.87 452.803Z",
    fill: "#005",
    fillOpacity: 0.565,
    strokeOpacity: 0.753,
    strokeWidth: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.397 444.862C199.58 444.862 207.025 437.416 207.025 428.233C207.025 419.049 199.58 411.604 190.397 411.604C181.213 411.604 173.768 419.049 173.768 428.233C173.768 437.416 181.213 444.862 190.397 444.862Z",
    fill: "#005",
    fillOpacity: 0.576,
    strokeOpacity: 0.769,
    strokeWidth: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.16 1.36133L1340.92 3.15288L2500.05 117.107L1313.16 1.36133ZM1298.63 15.8821L1328.17 17.7041L2501.8 118.85L1298.63 15.8821ZM1269.59 44.9237L1301.15 46.777L2503.54 120.592L1269.59 44.9237ZM2427.29 152.416L2461.17 154.302L2505.28 122.334L2427.29 152.416Z",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2412.76 166.938L2449.32 168.858L2507.02 124.078L2412.76 166.938Z",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2398.88 181.458L2438.6 183.413L2508.77 125.82L2398.88 181.458Z",
    strokeOpacity: 0.627,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2384.36 195.979L2427.8 197.97L2510.51 127.563L2384.36 195.979Z",
    strokeOpacity: 0.627,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2371.32 210.502L2419.32 212.53L2512.25 129.307L2371.32 210.502Z",
    strokeOpacity: 0.627,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2356.8 225.02L2410.33 227.087L2513.99 131.047L2356.8 225.02Z",
    strokeOpacity: 0.627,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2345.3 239.883L2405.97 241.997L2515.74 132.791L2345.3 239.883Z",
    strokeOpacity: 0.627,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330.78 254.404L2400.55 256.561L2517.48 134.534L2330.78 254.404Z",
    strokeOpacity: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2320.48 269.531L2402.86 271.744L2519.22 136.275L2320.48 269.531Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305.96 284.053L2405.99 286.312L2520.96 138.019L2305.96 284.053Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2295.87 299.343L2423.66 301.666L2522.71 139.759L2295.87 299.343Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2281.35 313.864L2457.07 316.238L2524.45 141.502L2281.35 313.864Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2270.59 329.242L2552.65 331.688L2526.19 143.246L2270.59 329.242Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2256.07 343.763L2961.22 346.264L2527.93 144.988L2256.07 343.763Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2244.82 358.862L1397.53 361.435L2529.68 146.73L2244.82 358.862Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230.3 373.382L1876.74 376.017L2531.42 148.472L2230.3 373.382Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2218.89 388.515L2016.32 391.229L2533.16 150.214L2218.89 388.515Z",
    strokeOpacity: 0.627,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2204.37 403.037L2062.57 405.818L2534.9 151.958L2204.37 403.037Z",
    strokeOpacity: 0.627,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193.16 418.255L2083.78 421.126L2536.65 153.7L2193.16 418.255Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2178.64 432.776L2089.77 435.723L2538.39 155.443L2178.64 432.776Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2167.32 447.779L2092.28 450.818L2540.13 157.185L2167.32 447.779Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152.8 462.3L2087.99 465.424L2541.87 158.928L2152.8 462.3Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140.94 477.048L2083.78 480.267L2543.62 160.67L2140.94 477.048Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2126.42 491.568L2075.39 494.882L2545.36 162.413L2126.42 491.568Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2113.75 506.356L2067.58 509.779L2547.1 164.156L2113.75 506.356Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2099.23 520.876L2057.14 524.405L2548.84 165.897L2099.23 520.876Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085.75 535.766L2047.04 539.421L2550.59 167.64L2085.75 535.766Z",
    strokeOpacity: 0.627,
    strokeWidth: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2071.23 550.287L2035.42 554.064L2552.33 169.383L2071.23 550.287Z",
    strokeOpacity: 0.627,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2057.11 565.144L2023.79 569.062L2554.07 171.126L2057.11 565.144Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042.59 579.663L2011.44 583.722L2555.81 172.868L2042.59 579.663Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2028.09 594.54L1998.85 598.762L2557.56 174.609L2028.09 594.54Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2013.57 609.062L1986.02 613.447L2559.3 176.353L2013.57 609.062Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1998.86 624.072L1972.81 628.651L2561.04 178.096L1998.86 624.072Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1984.34 638.592L1959.64 643.362L2562.78 179.838L1984.34 638.592Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1969.24 653.504L1945.76 658.498L2564.53 181.581L1969.24 653.504Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1954.72 668.023L1932.34 673.245L2566.27 183.322L1954.72 668.023Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939.42 682.823L1918.06 688.306L2568.01 185.065L1939.42 682.823Z",
    strokeOpacity: 0.627,
    strokeWidth: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924.9 697.344L1904.46 703.102L2569.75 186.808L1924.9 697.344Z",
    strokeOpacity: 0.627,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.38 712.052L1889.79 718.122L2571.5 188.55L1909.38 712.052Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.85 726.572L1876.04 732.98L2573.24 190.292L1894.85 726.572Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879.11 741.296L1861.03 748.093L2574.98 192.034L1879.11 741.296Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.59 755.818L1847.17 763.039L2576.72 193.777L1864.59 755.818Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.01 770.543L1832.22 778.26L2578.47 195.52L1849.01 770.543Z",
    strokeOpacity: 0.627,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2569.24 150.505C2587.69 150.505 2602.64 135.552 2602.64 117.107C2602.64 98.6627 2587.69 83.71 2569.24 83.71C2550.8 83.71 2535.84 98.6627 2535.84 117.107C2535.84 135.552 2550.8 150.505 2569.24 150.505Z",
    fill: "#005",
    fillOpacity: 0.541,
    strokeOpacity: 0.722,
    strokeWidth: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2569.7 139.857C2582.26 139.857 2592.45 129.672 2592.45 117.108C2592.45 104.543 2582.26 94.3584 2569.7 94.3584C2557.13 94.3584 2546.95 104.543 2546.95 117.108C2546.95 129.672 2557.13 139.857 2569.7 139.857Z",
    fill: "#005",
    fillOpacity: 0.553,
    strokeOpacity: 0.737,
    strokeWidth: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2431.75 151.958C2451 151.958 2466.6 136.355 2466.6 117.108C2466.6 97.8611 2451 82.2583 2431.75 82.2583C2412.5 82.2583 2396.9 97.8611 2396.9 117.108C2396.9 136.355 2412.5 151.958 2431.75 151.958Z",
    fill: "#005",
    fillOpacity: 0.565,
    strokeOpacity: 0.753,
    strokeWidth: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2429.4 140.825C2442.49 140.825 2453.11 130.207 2453.11 117.108C2453.11 104.01 2442.49 93.3911 2429.4 93.3911C2416.3 93.3911 2405.68 104.01 2405.68 117.108C2405.68 130.207 2416.3 140.825 2429.4 140.825Z",
    fill: "#005",
    fillOpacity: 0.576,
    strokeOpacity: 0.769,
    strokeWidth: 4.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .614)",
    d: "M0 0H2905V1029H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashje);
export default __webpack_public_path__ + "static/media/splashje.f92bc58d8775f14802d97eeef925a4b5.svg";
export { ForwardRef as ReactComponent };